export const levels = {
    basic: "basico",
    intermediate: "intermedio",
    avanzado: "avanzado"
}
    
